// @flow
import { INSTAGRAM_GRID } from 'Client/cms/toolkit/constants';
import { buildProductArgs } from 'Utils/graphql';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_INSTAGRAM_GRID } from 'Utils/request/requestDictionary';

type CMSProps = {
  title: string,
  morePicturesLabel: string,
  morePicturesButtonLabel: string,
  resortId: string,
};

export const productInstagramResolver = {
  name: INSTAGRAM_GRID,
  resolve(
    appContext: AppContext,
    props: CMSProps,
    pageContext: PageContext,
    location: RouterLocation<UrlParams>,
  ) {
    const { resortId } = props;
    const { urlParams } = location;
    const productArgs = buildProductArgs(resortId, urlParams);

    const query = `query {
      socialPictures(${productArgs}) {
        imageLarge,
        imageSmall,
        userName,
        canonicalUrl,
      }
    }`;

    return graphQLClient
      .runQuery(query, appContext, {
        requestName: LINE_PRODUCT_INSTAGRAM_GRID,
        strictErrors: false,
      })
      .catch(() => []);
  },
};
